// @flow
import * as React from 'react'
import type { Handbook } from 'gql/handbook'
import ContentWidthConstraint from 'ui/ContentWidthConstraint'

import './Viewer.module.scss'

type Props = {
  handbook: Handbook,
}

export default function Viewer(props: Props) {
  const { handbook } = props

  return (
    <ContentWidthConstraint narrow>
      <div styleName="container">
        <div className="handbook" dangerouslySetInnerHTML={{ __html: handbook.htmlContent }} />
      </div>
    </ContentWidthConstraint>
  )
}
